import * as React from "react";
import {cx} from "emotion";

import "./pdf-download.scss";

import {IsShowPricing}  from "@Common/logic/check-show-pricing";
import {cs}             from "@Common/react/chain-services";
import {SliderCheckbox} from "@Common/ui-components/slider-checkbox/slider-checkbox";

import { MoneySpanOld } from "../../../../../common/form/money-span/money-span";

export const PdfDownload = ({className, state, pdfDownloadPrice}) => cs(
    ({}, next) => pdfDownloadPrice == null ? null : next(),
    ["showPricing", (_, next) => IsShowPricing({next})],
    ({showPricing}) => (
        <div className={cx("pdf-download-4r5", className)}>
            <div className="line">
                <div className="left">
                    <div className="title">
                        PDF Download{" "}
                        {showPricing && (
                            MoneySpanOld({
                                value: pdfDownloadPrice ?? 0,
                            })
                        )}
                    </div>
                    <div className="sub-title">Include a high-resolution PDF</div>
                </div>
                <SliderCheckbox {...{
                    ...state,
                    xdQaName: "PDF Download",
                }}/>
            </div>
        </div>
    )
);
